const development_version = 'CL_SC_V0007.A_DEV';
const production_version = 'CL_SC_V0007.A';
export const version =
    process.env.VUE_APP_VERSION_TYPE === 'production'
        ? production_version
        : development_version;
